import styled from 'styled-components';
import { GroupButtonStyledProps, GroupButtonProps } from './type';

export const GroupButtonStyled = styled.button<GroupButtonStyledProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ padding }) => padding};
  border: 0px;
  color: ${({ active, color }) => (active ? '#FFF' : `${color || '#1F89FF'}`)};
  background-color: ${({ active, color }) => (active ? `${color || '#1F89FF'}` : '#FFF')};
  font-family: Poppins;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.2;
  text-align: center;
  position: relative;

  ${({ disabled }) => {
    if (disabled) {
      return `
        cursor: not-allowed;
        color: #8E90A4;
        background-color: #CFD0D8;
        `;
    }
    return `
      cursor: pointer;
    `;
  }}

  ${({ gap, orientation, active }) => {
    if (gap !== '0px') {
      return `
        border-radius: 8px;
        ${!active && 'box-shadow: 3px 1px 5.2px 0px rgba(140, 140, 140, 0.25);'}
      `;
    }
    return orientation === 'horizontal'
      ? `
      width: min-content;
      &:last-child {
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
      }
      &:first-child {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
      }
      &:before{
        visibility: ${active ? 'hidden' : 'visible'};
        content: '';
        top: 0;
        left: 0;
        z-index: -1;
        width: 100%;
        height: 100%;
        position: absolute;
      }
      &:not(:first-child):not(:last-child):before{
        overflow-x: hidden;
        overflow-y: visible;
        box-shadow: 0px 1px 5.2px 1px rgba(140, 140, 140, 0.25);
      }
      &:first-child:before {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        box-shadow: -3px 1px 5.2px 1px rgba(140, 140, 140, 0.25);
      }
      &:last-child:before {
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
        box-shadow: 3px 1px 5.2px 1px rgba(140, 140, 140, 0.25);
      }
    `
      : `
      width: 100%;
      &:first-child {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
      }
      &:last-child {
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      }
  `;
  }}
`;

export const GroupButtonWrapper = styled.div<GroupButtonProps>`
  display: flex;
  flex-direction: ${({ orientation }) => (orientation === 'horizontal' ? 'row' : 'column')};
  ${({ gap }) =>
    gap === '0px'
      ? `
      gap: 0px;
      // box-shadow: 3px 1px 5.2px 0px rgba(140, 140, 140, 0.25);
    `
      : `
      gap: ${gap};
    `};

  width: max-content;
  border-radius: 8px;
`;
